import { render, staticRenderFns } from "./registerAccount.vue?vue&type=template&id=4eb27ec4&scoped=true"
import script from "./registerAccount.vue?vue&type=script&lang=js"
export * from "./registerAccount.vue?vue&type=script&lang=js"
import style0 from "./registerAccount.vue?vue&type=style&index=0&id=4eb27ec4&prod&lang=scss"
import style1 from "./registerAccount.vue?vue&type=style&index=1&id=4eb27ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb27ec4",
  null
  
)

export default component.exports